import React from 'react';
import Chip from '@mui/material/Chip';

export const workspaceStatusAccent = (theme, statusKey) => {
  const key = String(statusKey || '');
  if (key === 'attention' || key.startsWith('waiting_')) return theme.palette.warning.main;
  if (key === 'execution') return theme.palette.info.main;
  if (key === 'completed' || key === 'active') return theme.palette.success.main;
  return theme.palette.text.disabled;
};

export default function WorkspaceStatusChip({ status, ...props }) {
  const resolvedStatus = status || { key: 'active', label: 'Active', color: 'success' };
  return (
    <Chip
      size="small"
      variant={resolvedStatus.key === 'attention' || resolvedStatus.key === 'execution' ? 'filled' : 'outlined'}
      color={resolvedStatus.color}
      label={resolvedStatus.label}
      {...props}
      sx={{
        height: 26,
        fontWeight: 700,
        '& .MuiChip-label': { px: 1.1 },
        ...props.sx,
      }}
    />
  );
}
